<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateStok from "./create_stock.vue"
import Transfer from "./transfer.vue"
import History from "./history.vue"

export default {
    page: {
        title: "Stok Yönetimi",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        CreateStok,
        Transfer,
        History
    },
    data() {
        return {
            list: {},
            title: "STOK LİSTESİ",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "STOK LİSTESİ",
                    active: true,
                },
                {
                    text: "DEPO ÜRÜN LİSTESİ",
                    active: true,
                },

            ],
            isLoading: false,
            rows: [],
            transferModal:0,
            historyModal:0,
            transferData:{amount:0},
            historyData:{},
            openModal:0
        };
    },
    mounted() {
        this.loadItems() 
    },
    methods: {
        loadItems() {
            this.$http.post('/stock/depo', this.serverParams)
                .then(response => {
                    const groupedData = {};
                    response.data.forEach(item => {
                        if (!groupedData[item.user_name]) {
                            groupedData[item.user_name] = { 
                                    user_name: item.user_id == 1 ? 'Ana Depo' : item.user_name, 
                                    user_id: item.user_id, 
                                    class: item.user_id == 1 ? 'primary' : 'secondary', 
                                    stocks: [] 
                                }
                        }
                        groupedData[item.user_name].stocks.push({ stock_group_name: item.stock_group_name, amount: item.amount, unit:item.unit, 
                                    stock_group_id: item.stock_group_id  });
                    });
                    this.rows = Object.values(groupedData);
                })
        },
        create(){
            this.list = {}
            this.openModal += 1
            this.$parent.$bvModal.show('modal-scoped')
        },
        openTransferModal(props, stockIdx){
           const { user_id, user_name, stocks } = props
            this.transferModal +=1
            this.transferData = { user_id,user_name, ...stocks[stockIdx] }
            this.$parent.$bvModal.show('transfer')
        },
        openHistoryModal(user_id){
            this.historyModal +=1
            this.historyData = { user_id }
            this.$parent.$bvModal.show('history')
        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <CreateStok 
        :data="openModal" 
    />

    <Transfer 
        :openModal='transferModal'
        :data="transferData"
        @loadItems="loadItems"
    />

    <History 
        :openModal='historyModal'
        :data="historyData"
    />
    
    <div class="row mb-2">
        <div class="col-md-6">
            <h2>Kullanılabilir Durumdaki Depo Stokları</h2>
        </div>
        <div class="col-md-6 text-end">
            <button @click="create" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> Stoğa Yeni Ürün Ekle</button>
        </div>
    </div>
    <div class="row mb-0">
        <div class="col-12" v-for="(row, i) in rows" :key="i">
            <div class="card" style="border-left:solid 5px" :class="`border-${row.class}`">
                <div class="card-header bg-soft d-flex justify-content-between" :class="`bg-${row.class}`">
                    <h5 class="mb-0">{{ row.user_name }} </h5>
                    <button class="btn btn-sm btn-outline-secondary" @click="openHistoryModal(row.user_id)">Depo Hareketleri</button>
                </div>
                <div class="row">
                    <div class="table-responsive mb-0">
                        <table class="table">
                            <tbody>
                                <tr v-for="(stock, b) in row.stocks" :key="b">
                                    <th style="vertical-align:middle">
                                       {{ stock.stock_group_name }}
                                    </th>
                                    <th style="vertical-align:middle" class="text-end">
                                        <div style="border:solid 1px;display:inline-block;font-weight:400;line-height: 1.5;text-align: center;vertical-align: middle;padding:0.25rem 0.5rem;font-size: 0.8125rem;border-radius: 0.25rem;min-width:300px">
                                            <span class="text-muted">Stok miktarı  </span>
                                            <b>{{ stock.amount }} </b>
                                            <span class="text-muted">({{ stock.unit }}) </span> 
                                        </div>
                                    </th>
                                    <th class="text-end" style="width:170px">
                                       <button class="btn btn-sm btn-outline-warning" @click="openTransferModal(row,b)">Depoya Transfer Et</button>
                                    </th>
                                    <th class="text-end" style="width:140px">
                                       <button class="btn btn-sm  btn-outline-info">Ürün Detayları</button>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
  </Layout>
</template>